import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/auth-store";
import { CheckCircle, Loader2 } from "lucide-react";

export function AuthSuccessPage() {
  const navigate = useNavigate();
  const { init } = useAuthStore();
  const [done, setDone] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const apiUrl = params.get("api_url");

    if (token) {
      init(params);

      if (window.opener) {
        window.opener.postMessage(
          { type: "AI_CRM_TOKEN", token, api_url: apiUrl },
          "*",
        );
        setDone(true);
        setTimeout(() => window.close(), 1500);
      } else if (window.parent !== window) {
        window.parent.postMessage(
          { type: "AI_CRM_TOKEN", token, api_url: apiUrl },
          "*",
        );
        setDone(true);
        setTimeout(() => navigate("/settings"), 2000);
      } else {
        setDone(true);
        setTimeout(() => navigate("/settings"), 2000);
      }
    }
  }, [init, navigate]);

  if (!done) {
    return (
      <div className="flex h-screen flex-col items-center justify-center gap-3 p-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-sm text-muted-foreground">Авторизация...</p>
      </div>
    );
  }

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-3 p-4 text-center">
      <CheckCircle className="h-10 w-10 text-green-500" />
      <h1 className="text-lg font-semibold">Подключено!</h1>
      <p className="text-sm text-muted-foreground">
        Перенаправляем в настройки...
      </p>
    </div>
  );
}
